import React from "react";
import { Outlet } from "react-router-dom";
import SearchCips from "../components/SearchCips/SearchCips";

export default function CipLayout() {
  
  return (
    <div className="min-h-screen flex flex-col bg-zinc-50">


      {/* MAIN CONTENT AREA */}
      <div className="flex-grow grid grid-cols-12 p-4">
        {/* LEFT SIDEBAR */}
        <aside
  className="fixed overflow-y-auto top-0 left-0 h-screen lg:bg-white lg:border-r-2 xl:p-7 border-zinc-50 w-0 xl:w-full max-w-[20rem]  2xl:max-w-[23rem]"
  style={{ zIndex: 40 }}
>
  <SearchCips />
</aside>

        {/* MAIN CONTENT WRAPPER */}
        <div
          className="col-span-12 xl:ml-[20rem] 2xl:ml-[23rem] flex justify-center items-start"
        >
          {/* MAIN CONTENT */}
          <main
            className=" rounded-lg mx-auto w-full max-w-[69rem]"
          >
            <Outlet />
          </main>
        </div>
      </div>

      {/* FOOTER */}
      <footer className="bg-zinc-50 text-zinc-500 pr-11 p-4 mt-auto xl:ml-[20rem] 2xl:ml-[23rem]">
        <p className="text-end text-sm">© 2025 NuMetrics</p>
      </footer>
    </div>
  );
}